
























































import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";
import FloatingMenu from "@/components/Molecules/FloatingMenu/index.vue";
import FloatingMenuButton from "@/components/Atoms/FloatingMenuItems/FloatingMenuButton/index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "PopoverSelectBox",
  components: {
    FloatingMenu,
    FloatingMenuButton
  },
  props: {
    value: {
      type: [String, Number],
      default: undefined
    },
    title: {
      type: String as PropType<Props["title"]>,
      default: ""
    },
    options: {
      type: Array as PropType<Props["options"]>,
      required: true
    },
    size: {
      type: String as PropType<Props["size"]>,
      default: "medium",
      validator: function(value) {
        return ["small", "medium"].includes(value);
      }
    },
    position: {
      type: String as PropType<Props["position"]>,
      default: "left",
      validator(value) {
        return ["left", "center", "right"].includes(value);
      }
    },
    iconName: {
      type: String as PropType<Props["iconName"]>,
      default: ""
    },
    disabledBorder: {
      type: Boolean as PropType<Props["disabledBorder"]>,
      default: false
    }
  },
  data() {
    return {
      focus: false,
      buttonClass: {
        basic: "popoverSelectBox__floatingMenu__floatingMenuButton",
        active: "popoverSelectBox__floatingMenu__floatingMenuButton--active"
      }
    };
  },
  computed: {
    sizeClass() {
      return {
        "popoverSelectBox--size--small": this.size === "small",
        "popoverSelectBox--size--medium": this.size === "medium"
      };
    },
    focusClass() {
      return {
        "popoverSelectBox--focus": this.focus
      };
    },
    positionClass() {
      return {
        "popoverSelectBox--position--left": this.position === "left",
        "popoverSelectBox--position--center": this.position === "center",
        "popoverSelectBox--position--right": this.position === "right"
      };
    },
    selectedItem() {
      const index = this.options.findIndex(option => {
        return option.value === this.value;
      });
      return this.options[index];
    },
    positionCenterStyle() {
      // TODO: 非表示状態で、 floatingMenuWidth を取得する方法の調査
      const floatingMenuWidth = 270;
      return this.position === "center"
        ? {
            width: `${floatingMenuWidth}px`,
            left: `calc(50% - (${floatingMenuWidth}px / 2))`
          }
        : {};
    }
  },
  methods: {
    handleClickOutside() {
      this.focus = false;
    },
    handleEventClickMenu(value) {
      this.focus = false;
      this.$emit("input", value);
    },
    onFocus() {
      this.focus = true;
    }
  }
});
